import React, {useMemo} from 'react';
import {useColorThemeType, useFontTheme} from '@buncha/appStyles/hooks/theme';

import {H6Text} from '@buncha/components/core/text';
import {HBox} from '@buncha/components/core/view';
import HourGlass from '@buncha/components/core/icon/HourGlass';
import {Info} from '@buncha/components/core/icon';
import {styles} from './styles';

interface Props {
  itemUnit?: string | number;
  quantity: number;
}

const WeightAndQtyPill = (props: Props) => {
  const theme = useColorThemeType();
  const muliFont = useFontTheme('muli');

  const {itemUnit, quantity} = props;

  const getIcon = useMemo(() => {
    if (itemUnit)
      return (
        <HourGlass
          fill={theme?.background.blue[300]}
          height={20}
          width={20}
          viewBox="0 -7 15 25"
        />
      );
    return (
      <Info
        height={16}
        width={16}
        viewBox="0 0 20 20"
        fill={theme?.icon.blue[300]}
      />
    );
  }, [itemUnit, theme?.background.blue, theme?.icon.blue]);

  const getItemUnitText = useMemo(() => {
    if (itemUnit) return `Weight - ${itemUnit}`;
    return `Pick Qty: ${quantity || 0}`;
  }, [itemUnit, quantity]);

  return (
    <HBox
      style={[
        styles.infoBox,
        {
          backgroundColor: theme?.background.yellow[200],
        },
      ]}>
      {getIcon}
      <H6Text
        style={[
          styles.infoText,
          {
            color: theme?.text.blue[300],
            fontFamily: muliFont[700].normal,
          },
        ]}>
        {getItemUnitText}
      </H6Text>
    </HBox>
  );
};

export default React.memo(WeightAndQtyPill);
